<template>
  <div class="BusinessMap">
    <GoogleMap
      id="1"
      :mapCenter="localizacion"
      :height="368"
      :heatmapData="heatmapData"
    />
  </div>
</template>

        console.log(data)
<script>
import { GoogleMap } from '@/components/Charts';
import { getCoordinatesMap } from '@/api';

export default {
  name: 'BusinessMap',
  data() {
    return {
      heatmapData: [],
      localizacion: {
        latitude: '40.4763025',
        longitude: '-3.6878875',
      },
    };
  },
  components: {
    GoogleMap,
  },
  created() {
    getCoordinatesMap().then(
      data => {
        this.heatmapData = data;
      },
      err => {
        console.log('Fetch Error: ', err);
      }
    );
  },
};
</script>

<style lang="scss">
.BusinessMap {
  width: 35%;
  margin-left: rem(10);
}
</style>
